import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatProductToDisplay } from 'utils/admin-products';
import { getProductById } from 'services/api/admin-products';
import { Toast } from 'shared-components/BaseToast/Toast';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import ProductForm from '../ProductForm/ProductForm';

const EditProduct = () => {
  const { id } = useParams();
  const [initialProductData, setInitialProductData] = useState({});
  const [initialMetadataMap, setInitialMetadataMap] = useState({});

  //reformat product data
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await getProductById(id);
        const formattedProductData = formatProductToDisplay(response);
        const { variantMetadataMap } = response;
        setInitialProductData(formattedProductData);
        setInitialMetadataMap(variantMetadataMap);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProduct();
  }, []);

  const { productName } = initialProductData;
  return (
    <PageContainer>
      <ProductForm
        title={productName ? `Edit Product: ${productName}` : 'Edit Product'}
        initialProductData={initialProductData}
        initialMetadataMap={initialMetadataMap}
        setInitialProductData={setInitialProductData}
        setInitialMetadataMap={setInitialMetadataMap}
      />
      <Toast />
    </PageContainer>
  );
};

export default EditProduct;
